export default "__VITE_ASSET__7b04f6d9__"